import toast from "toasted-notes";
import "toasted-notes/src/styles.css";

export default toast;
